import { VALID_ROUTE_SEGMENT_REGEX } from 'src/utilities/regexPatterns';

export const hasMalformedPathname = (pathname: string): boolean =>
  pathname
    .split('/')
    .filter(Boolean)
    .some((segment) => !VALID_ROUTE_SEGMENT_REGEX.test(segment));
